<template>
  <div class="about">
    <page-header :heading="'Settings'" />
    <div class="wrapper">
      <div
        class="max-w-2xl mx-auto px-8 py-8 -mt-12 bg-white rounded-lg shadow-md"
      >
        <h2 class="mb-4 text-lg text-center border-b-2 pb-3 border-gray-100">
          Your API Tokens
        </h2>
        <h3 class="text-sm font-bold">ID Token</h3>
        <p class="text-sm break-all">{{ idToken }}</p>
        <h3 class="mt-6 text-sm font-bold">Refresh Token</h3>
        <p class="text-sm break-all">{{ refreshToken }}</p>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Auth, Analytics } from "aws-amplify";
import PageHeader from "@/components/PageHeader";

export default {
  name: "Account",
  components: {
    PageHeader,
  },
  data() {
    return {
      idToken: null,
      refreshToken: null,
    };
  },
  methods: {
    async getTokens() {
      Auth.currentSession().then((res) => {
        let idToken = res.getIdToken();
        this.idToken = idToken.getJwtToken();

        this.refreshToken = res.refreshToken.token;
      });
    },
  },
  created() {
    this.getTokens();
    Analytics.record({ name: "viewedSettings" });
  },
};
</script>
